import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import BaseCosmic from '~/nasa_ui/base/BaseCosmic';
import CurrentUserMixin, { setActiveSupportContext } from '~/nasa_ui/mixins/CurrentUserMixin';
import { AlertType } from '~/nasa_ui/types';
import { CosmicUserSupportContext, CosmicUserSupportContextDisplay } from '~/nasa_ui/types/cosmic/system';
import { sortObjectBy } from '~/nasa_ui/utils';
let ActiveUserSupportsDisplay = class ActiveUserSupportsDisplay extends Mixins(BaseCosmic, CurrentUserMixin) {
    CosmicUserSupportContext = CosmicUserSupportContext;
    CosmicUserSupportContextDisplay = CosmicUserSupportContextDisplay;
    currentUserSupportContext = null;
    isReloading = false;
    pollingTimerId = null;
    get selectOptions() {
        if (!this.currentUserSupportContexts) {
            return [];
        }
        const supports = this.currentUserSupportContexts.filter((support) => {
            // Filter out the current selected ctx
            return support?.organizationCode !== this.currentUserSupportContext;
        });
        supports.sort(sortObjectBy('organizationCode'));
        return supports;
    }
    get currentUserSupportContextCount() {
        return this.currentUserSupportContexts?.length || 0;
    }
    get showUserSupportContextList() {
        return this.currentUserSupportContextCount > 1;
    }
    get hasOnlyOneContext() {
        return this.currentUserSupportContextCount === 1;
    }
    created() {
        this.pollLocalStorage();
    }
    handleUserSupportSelection(support) {
        if (!support.organizationCode) {
            return;
        }
        // save current user support context and reload
        this.setCurrentUserSupport(support.organizationCode);
    }
    setCurrentUserSupport(organizationCode) {
        setActiveSupportContext(organizationCode);
        // if its the home page, just push the new context
        if (this.$route.path === '/') {
            this.$router.push({
                query: {
                    ctx: organizationCode
                }
            });
        }
        // if its a report, all that as well just push new context
        else if (this.$route.path.includes('reporting')) {
            this.$router.push({
                query: {
                    ctx: organizationCode
                }
            });
        }
        // if youre an ADMIN and youre on a user manage page, allow that
        else if (this.$route.path.includes('users/manage') && this.currentUserIsAdmin) {
            this.$router.push({
                query: {
                    ctx: organizationCode
                }
            });
        }
        else {
            this.$router.push({
                path: '/',
                query: {
                    ctx: organizationCode
                }
            });
        }
        this.$notification.add({
            type: AlertType.SUCCESS,
            text: `${CosmicUserSupportContextDisplay.get(organizationCode)} loaded. Reloading to complete.`
        });
        // reload page
        setTimeout(() => {
            this.isReloading = true;
            location.reload();
        }, 1000);
    }
    pollLocalStorage() {
        this.pollingTimerId = setInterval(() => {
            if (this.currentUserActiveSupportContext) {
                this.currentUserSupportContext = this.currentUserActiveSupportContext;
                if (this.pollingTimerId) {
                    clearInterval(this.pollingTimerId);
                    this.pollingTimerId = null;
                }
            }
        }, 150);
    }
    beforeDestroy() {
        if (this.pollingTimerId) {
            clearInterval(this.pollingTimerId);
        }
    }
};
ActiveUserSupportsDisplay = __decorate([
    Component
], ActiveUserSupportsDisplay);
export default ActiveUserSupportsDisplay;
